import { useEffect, useState } from 'react'
import s from './styles.module.scss'
import rs from './responsiveStyles.module.scss'
import { Link } from 'react-router-dom'
import { Data8Service } from '../../../services'

interface checkboxProps {
    fieldName: string
    label: string | React.ReactNode
    saveValue: (obj: { field: string; value: string }) => { success: boolean; error: string }
    initialValue?: string
}

export const Checkbox = (props: checkboxProps) => {
    const { fieldName, saveValue, label, initialValue } = props
    const [boxChecked, setBoxChecked] = useState(initialValue === 'yes')

    useEffect(() => {
        if (initialValue === 'yes' && !boxChecked) {
            setBoxChecked(true)
        }
    }, [initialValue])

    useEffect(() => {
        saveValue({ field: fieldName, value: boxChecked ? 'yes' : 'no' })
        console.log('BOX CHECKED: ', boxChecked)
    }, [boxChecked])

    const click = async (e: React.MouseEvent) => {
        setBoxChecked(!boxChecked)
    }

    const handleLabelClick = (e: React.MouseEvent) => {
        // Don't toggle checkbox if clicking on a link
        if ((e.target as HTMLElement).tagName === 'A') {
            return
        }
        setBoxChecked(!boxChecked)
    }

    return (
        <div onClick={handleLabelClick} className={`${s.checkbox} ${rs.checkbox}`}>
            <span className={`${boxChecked ? s.checked : ''}`}></span>
            <p>{label}</p>
        </div>
    )
}
